module.exports = __webpack_public_path__ + "media/registration/class-of-icon-77c00d93.svg";